<template>
	<div class="container-fluid">
		<div class="border-top pt-2"></div>
		<div class="row d-flex justify-content-center">
			<div class="col-12 h3 font-weight-bold">
				Összes termék:
			</div>
			<div
				:class="[allProducts ? 'col-lg-6 col-md-6' : 'col-12']"
				v-for="(item_pr,index) in products"
				:key="`pr-${index}`"
			>
				<orderitem
					:tszam="item_pr.tszam"
					:nev="item_pr.nev"
					:ar="item_pr.ar"
					:db="item_pr.db"
					:allProducts="allProducts"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import orderitem from './order_item'
export default {
	name: 'products',

	props: ['allProducts'],
	
	components: {
		orderitem
	},

	data() {
		return {
			products: []
		}
	},

	mounted(){
		this.$Progress.start()
		this.req.post('products/search', {
			search: { aktiv: 1 }
		})
			.then(res => {
				this.products = res.data.products
				this.$Progress.finish()
			})
			.catch(err => {
				console.log(err)
				this.$Progress.fail()
			})
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/products.vue